import {
  goHomeIfNoCorrelationId,
  handleOidcLoginRedirect,
  handleSamlLoginRedirect,
  redirectIfNoPublicLogin,
  redirectIfNoTenantFinder,
  redirectToPublicLoginIfNeeded,
  redirectToSsoLoginIfUsingSso,
  redirectToTenantFinderIfNoSubdomain,
} from '@/login/router/guards';
import { IS_PUBLIC, NO_AUTH_NEEDED } from '@/types';

const LoginWelcomeBackPage = () => import('@/login/pages/login-welcome-back.vue');
const LoginUniversalLoginPage = () => import('@/login/pages/login-universal-login.vue');
const LoginPublicLoginPage = () => import('@/login/pages/login-public-login.vue');
const LoginHrdVerifyPage = () => import('@/login/pages/login-hrd-verify.vue');
const LoginForgotPasswordPage = () => import('@/login/pages/login-forgot-password.vue');
const LoginEmailSentPage = () => import('@/login/pages/login-email-sent.vue');
const LoginPasswordUpdatedPage = () => import('@/login/pages/login-password-updated.vue');
const LoginTokenExpiredPage = () => import('@/login/pages/login-token-expired.vue');
const LoginValidateTokenPage = () => import('@/login/pages/login-validate-token.vue');
const LoginMfaTokenPage = () => import('@/login/pages/login-mfa-token.vue');
const LoginInvitePage = () => import('@/login/pages/login-invite.vue');
const LoginSamlLoginPage = () => import('@/login/pages/login-saml-login.vue');
const LoginOidcLoginPage = () => import('@/login/pages/login-oidc-login.vue');
const LoginOidcErrorPage = () => import('@/login/pages/login-oidc-error.vue');
const LoginSsoFirstLoginPage = () => import('@/login/pages/sso-first-login.vue');
const LoginTempPasswordChangePage = () => import('@/login/pages/login-temp-password-change.vue');
const LoggedOutPage = () => import('@/login/pages/logged-out.vue');

export const loginRoutes = [
  {
    path: '/login',
    name: 'universal-login',
    component: LoginUniversalLoginPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      [IS_PUBLIC]: true,
      layout: 'layout-login',
    },
    beforeEnter: [redirectIfNoTenantFinder],
  },
  {
    path: '/public-login',
    name: 'public-login',
    component: LoginPublicLoginPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      [IS_PUBLIC]: true,
      layout: 'layout-login',
    },
    beforeEnter: [redirectIfNoPublicLogin],
  },
  {
    path: '/auth/hrd-verify',
    name: 'hrd-verify',
    component: LoginHrdVerifyPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      [IS_PUBLIC]: true,
      layout: 'layout-login',
    },
  },
  {
    path: '/welcome-back',
    name: 'welcome-back',
    component: LoginWelcomeBackPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
    beforeEnter: [redirectToPublicLoginIfNeeded, redirectToTenantFinderIfNoSubdomain, redirectToSsoLoginIfUsingSso],
  },
  {
    path: '/loginadmin',
    name: 'login-admin',
    component: LoginWelcomeBackPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  // Forgot password
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: LoginForgotPasswordPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  {
    path: '/forgot-password/:token',
    name: 'validate-token',
    component: LoginValidateTokenPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  {
    path: '/email-sent',
    name: 'email-sent',
    component: LoginEmailSentPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  {
    path: '/logged-out',
    name: 'logged-out',
    component: LoggedOutPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  {
    path: '/password-updated',
    name: 'password-updated',
    component: LoginPasswordUpdatedPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  {
    path: '/token-expired',
    name: 'token-expired',
    component: LoginTokenExpiredPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  // End forgot password
  {
    path: '/mfa-token',
    name: 'mfa-token',
    component: LoginMfaTokenPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
    beforeEnter: [goHomeIfNoCorrelationId],
  },
  {
    path: '/invite/:id',
    name: 'invite',
    component: LoginInvitePage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-empty',
    },
  },
  {
    path: '/saml/login',
    name: 'saml-login',
    component: LoginSamlLoginPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      [IS_PUBLIC]: true,
    },
    beforeEnter: [handleSamlLoginRedirect],
  },
  {
    path: '/oidc/login',
    name: 'oidc-login',
    component: LoginOidcLoginPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
    },
    beforeEnter: [handleOidcLoginRedirect],
  },
  {
    path: '/oidc/error',
    name: 'oidc-error',
    component: LoginOidcErrorPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-login',
    },
  },
  {
    path: '/first-login',
    name: 'first-login',
    component: LoginSsoFirstLoginPage,
    meta: {
      layout: 'layout-empty',
    },
  },
  {
    path: '/temp-password-change',
    name: 'temp-password-change',
    component: LoginTempPasswordChangePage,
    meta: {
      layout: 'layout-login',
    },
  },
];
